<template>
	<ul class="list-unstyled text-muted ml-2">
		<li v-for="pasta in subpastas" :key="pasta.id">
			<div>
				<a
					class="clickable text-muted"
					@click="
						getFiles(pasta);
						pastaSelected = pasta;
					"
				>
					<i
						class="mdi"
						:class="verifySelected(pasta.id) ? 'mdi-folder-open' : 'mdi-folder '"
						style="color: rgb(3, 173, 217)"
					></i>
					{{ pasta.nome }}
				</a>
				<arvore-subpasta
					v-show="verifySelected(pasta.id)"
					:subpastas="pasta.subpastas"
					:path-current="pathCurrent"
					:selected-pasta-box="selectedPastaBox"
					@load="getFiles"
				/>
			</div>
		</li>
	</ul>
</template>
<script>
export default {
	props: ["subpastas", "selectedPastaBox", "pathCurrent"],
	data() {
		return { pastaSelected: "" };
	},
	watch: {
		pastasArvore(n, o) {
			this.pastas = this.pastasArvore;
		},
		selectedPastaBox(n, o) {
			var result = this.subpastas.filter(
				(pasta) => pasta.id == this.selectedPastaBox.id
			);
			if (result.length > 0) {
				this.pastaSelected = this.selectedPastaBox;
			}
		},
	},
	methods: {
		getFiles(pasta) {
			this.$emit("load", pasta);
			this.$emit("clicksub");
		},
		verifySelected(id) {
			return this.pastaSelected.id == id ? true : false;
		},
	},
};
</script>
<style lang="css">
.clickable {
	cursor: pointer;
}
.show_folder {
	display: block;
}
ul ul a {
	background: #ffffff !important;
}
</style>
